export const ADD_TO_CART_REQUEST = "ADD_TO_CART_REQUEST"
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS"
export const ADD_TO_CART_FAIL = "ADD_TO_CART_FAIL"
export const DELETE_ITEM_REQUES = "DELETE_ITEM_REQUES"
export const CLEAR_ERRORS = "CLEAR_ERRORS"